<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\searchCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào khóa học muốn học được hiển thị trên trang chủ hoặc tìm kiếm bằng từ khóa liên quan trong ô tìm kiếm.</p>
                </div>
                <div><img src="/static\images\vi\newManual\searchCourseManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhấn vào khóa học muốn học, sẽ di chuyển đến màn hình chi tiết khóa học.</p>
                    <p>③ Từ lần login sau, những khóa học đã tham gia sẽ được hiển thị trong Khóa học của tôi theo thứ tự ngày tham gia.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/searchCourse_manual.vue